import { useAccount } from "@/react/hooks";
import { motion } from "framer-motion";
import { QRCodeSVG } from "qrcode.react";

export function WalletQR() {
  const { address } = useAccount();
  const qrCodeSize = 200;

  return (
    <div className="web3kit-flex web3kit-flex-col web3kit-items-center web3kit-gap-4">
      <div className="web3kit-text-center">
        <p className="web3kit-text-sm web3kit-text-muted-foreground">
          Scan this QR code to send funds to your wallet
        </p>
      </div>

      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 0.3,
        }}
        className="web3kit-flex web3kit-items-center web3kit-justify-center web3kit-p-4 web3kit-bg-white web3kit-rounded-lg"
      >
        <QRCodeSVG
          value={address}
          size={qrCodeSize}
          level="H"
          marginSize={1}
          className="web3kit-border web3kit-rounded-lg"
        />
      </motion.div>
    </div>
  );
}
